import React, {Component, Fragment} from "react";
import {createRoot} from "react-dom/client";
import AssetGrid from "../components/Grid/Grid";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import AmbassadorHeader from "../components/AmbassadorHeader/AmbassadorHeader";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import NoContent from "../components/NoContent/NoContent";
import AmbassadorHelper from "../utils/AmbassadorHelper";
import Api from "../utils/api_calls";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import Zoom from "../components/Zoom/Zoom";
import "../../sass/_document.scss";
import theme from "../../sass/variables.json";

class AmbassadorPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasContent: true,
            checkFinish: false
        }
    }
    getApiUrl() {
        return `${ConfigurationHelper.getGlobalConfiguration().apiUrl}channels/${ConfigurationHelper.getRelatedVideosChannelId()}/contents?user_id=${ConfigurationHelper.getGlobalConfiguration().ambassadorData.id}`;
    }
    componentDidMount() {
        const that = this;
        Api.content(this.getApiUrl(), 0, null).then(function (response) {
            const {data} = response;
            if (data.length > 0) {
                that.setState({
                    checkFinish: true
                });
            } else {
                that.setState({
                    checkFinish: true,
                    hasContent: false,

                });
            }
        })
    }

    render() {
        const {hasContent, checkFinish} = this.state;
        const apiUrl = this.getApiUrl();
        return <div className={theme.hub_wrapper_css_class}>
            {ConfigurationHelper.enableHeaderFooter() && <Header/>}
            <Breadcrumbs className={"tvp-breadcrumbs-container"} keepOnMobile breadcrumbsList={[{name: `${AmbassadorHelper.getDisplayName(TVSite.ambassadorData)}`, url: "#", active: true}]}/>
            <AmbassadorHeader/>
            <Zoom/>
            {(hasContent && checkFinish) && <Fragment>
                <div className={"container pb-1"}>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <div className="tvp-line-storefront">
                                <div className="text-left" style={{textTransform: "uppercase"}}>
                                    SHOP WITH ME
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            <AssetGrid
                baseApiUrl={apiUrl}
                gridTitle={" "}/>
            </Fragment>}

            {(!hasContent && checkFinish) && <NoContent>
                <div className={"text-center"}>I haven’t posted any content yet, please check back soon.</div>
            </NoContent>}

            {ConfigurationHelper.enableHeaderFooter() && <Footer/>}
        </div>
    }
}

export default AmbassadorPage;
const targetEl = document.getElementById("app-container");

if (targetEl){
    const root = createRoot(targetEl)
    root.render(<AmbassadorPage/>);
}